import axios from "axios";
import { refreshTokens } from "./AuthService";
import Cookies from "universal-cookie";
import { jwtDecode } from 'jwt-decode';

const client = axios.create({
    //baseURL: "http://localhost:8000/vacations"
    baseURL: "https://vp-backend-ysy4bqirgq-uc.a.run.app/vacations"
});

const cookies = new Cookies();
client.defaults.headers.common['Authorization'] = 'Bearer ' + cookies.get("jwt_authorization");


client.interceptors.response.use(resp => resp, async error => {   
    if (error.response.status === 401) {
        const data = {
            'refresh_token': cookies.get("refresh_token")
        }
        const response = await refreshTokens(JSON.stringify(data));

        if (response.id_token !== null) {
            client.defaults.headers.common['Authorization'] = 'Bearer ' + response.id_token;
            var userObject = jwtDecode(response.id_token);
            cookies.set("jwt_authorization", response.id_token, {
                expires: new Date(userObject.exp * 1000),
            });
            cookies.set("access_token", response.access_token, {
                expires: new Date(userObject.exp * 1000),
            });
            window.location.reload();
            return client(error.config);
        }
    }
});

export const grantVacations = async (body) => {
    const promise = client.post('/grant', body, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    const data = promise.then((response) => response);
    return data;
};

export const grantBulk = async (year) => {
    const promise = client.post('/grant-bulk', JSON.stringify({ year: year }), {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    const data = promise.then((response) => response);
    return data;
};

export const requestVacations = (body) => {
    const promise = client.post('/request', body, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    const data = promise.then((response) => response);
    return data;
};

export const cancelVacations = (body) => {
    const promise = client.post('/cancel', body, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    const data = promise.then((response) => response.data);
    return data;
};

export const rejectVacations = (body) => {
    const promise = client.post('/reject', body, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    const data = promise.then((response) => response.data);
    return data;
};

export const approveVacations = (body) => {
    const promise = client.post('/approve', body, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    const data = promise.then((response) => response.data);
    return data;
};

export const pendingVacationRequests = async () => {
    const promise = client.get('/pending_requests');
    const data = promise.then((response) => response.data);
    return data;
};

export const getVacationsSummary = async (employeeId, year) => {
    const promise = client.get('summary/'+employeeId+'&'+year);
    const data = promise.then((response) => response.data);
    return data;
};

export const getVacationsHistory = async (employeeId, year, filtered) => {
    const promise = client.get('/history/user_id='+employeeId+'&year='+year+'&filtered='+filtered);
    const data = promise.then((response) => response.data);
    return data;
};
